import { render, staticRenderFns } from "./SendMagicLinkAgainButton.vue?vue&type=template&id=6353c85e"
import script from "./SendMagicLinkAgainButton.vue?vue&type=script&lang=ts"
export * from "./SendMagicLinkAgainButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./SendMagicLinkAgainButton.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml&locale=fr"
if (typeof block0 === 'function') block0(component)

export default component.exports